import React, { useState, useContext, useEffect } from "react";
// Router
import { Route, Switch, useHistory } from "react-router-dom";
// Contexto
import ModalProvider from "../context/modalContext";
import ConfirmModalProvider from "../context/confirmModalContext";
import { AlertBoxContext } from "../context/alertBoxContext";
import Login from "./login";
import Root from "./Root";
import RecuperarContraseña from "./RecuperarContraseña";
import GuardedRoute from "./generic/GuardRoute";
import Footer from "./footer";
// Jquery
import $ from "jquery";

const refreshTimeoutTime = 2400000; // 40min

const App = () => {
  // Alertas
  const { addAlert } = useContext(AlertBoxContext);
  //Historial
  let history = useHistory();

  const [perfil, setPerfil] = useState();
  const [accessToken, setAccessToken] = useState();
  const [accessLevel, setAccessLevel] = useState(0);
  //const [intervals, setIntervals] = useState([]);
  const [refreshDone, setRefreshDone] = useState(false);
  const [refreshSuccess, setRefreshSuccess] = useState(false);
  const [profileSuccess, setProfileSuccess] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [refreshTimeout, setRefreshTimeout] = useState(null);

  // Lo primerito antes de iniciar.
  useEffect(() => {
    postRenewToken();
  }, []);

  useEffect(() => {
    // Refresh nada mas iniciar la app si ya tenenmos token
    if (loginSuccess || refreshSuccess) {
      getPerfil();
      clearTimeout(refreshTimeout);
      setRefreshTimeout(setTimeout(postRenewToken, refreshTimeoutTime));
      setAccessToken(accessToken);
      // localStorage.setItem("accessToken", accessToken);
    }
    return function cleanup() {
      clearTimeout(refreshTimeout);
    };
  }, [accessToken, loginSuccess, refreshSuccess]);

  // Funcion que se encarga de controlar los errores de la api
  const ErrorHandling = () => {
    // if (localStorage.getItem("isLogged") === "true" || isLogged === true) this.setAlert("Error - ", "Error en el servidor", "danger");
    if (loginSuccess) {
      addAlert("AVISO", "Puede no tener permiso para administrar esta sección o hay un error en los datos insertardos", "warning");
    }
  };

  //Función encargada de devolver si se han realizado las peticiones necesarias para iniciar la aplicación o no
  const isReady = () => {
    // El config aun no está hecho, solo se tienen en cuenta el refreshDone, refreshSuccess, loginSuccess, profileSuccess

    // console.log(`RD:${refreshDone}`);
    // console.log(`C:${configSuccess}`);
    // console.log(`RS:${refreshSuccess}`);
    // console.log(`PS:${profileSuccess}`);

    // console.log(
    //   configSuccess &&
    //     ((refreshDone && !refreshSuccess && !loginSuccess) ||
    //       (refreshDone && refreshSuccess && profileSuccess && customerSuccess) ||
    //       (loginSuccess && profileSuccess && customerSuccess))
    // );

    // C && [(RD && !RS && !LC) || (RD && RS && PS) || (LS && PS)]
    // C ennvuelve a todo, si no está cargado los parametros de configuración la aplicación no puede funcionar
    // 1º (RD && !RS && !LC) = Si se ha hecho la petición de refresh, ha dado error y no se esta intentando logear => gucci
    // 2º (RD && RS && PS && CS) = Si se ha hecho la petición de refresh, ha sido válida y se ha realizado correctamente la petición de perfil => gucci
    // 3º (LS && PS && CS) = Si se ha hecho petición de logear, ha sido válida y se ha realizado correctamente la petición de perfil => gucci

    return (refreshDone && !refreshSuccess && !loginSuccess) || (refreshDone && refreshSuccess && profileSuccess) || (loginSuccess && profileSuccess);
  };

  //********************************************** REQUESTS ****************************************************
  //------------------------------------------------ GET -------------------------------------------------------

  // Para obtener el perfil del usuario
  const getPerfil = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/perfil`,
      method: "GET",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    $.ajax(settings)
      .done((response) => {
        setPerfil(response);
       // console.log(`${process.env.REACT_APP_API_URL}/perfil`)
        //console.log(response.sister.destinations)
        setAccessLevel(response.accessLevel);
        setProfileSuccess(true);
        //console.log(response)
      })
      .fail((error) => {
        setProfileSuccess(false);
        addAlert("Error", "Los datos del usuario no han podido ser recuperados, algunas funciones pueden no estar disponibles", "danger");
      });

    // await $.ajax(settings)
    //   .done(function (response) {
    //     $this[0].setState({
    //       perfil: response,
    //     });
    //   })
    //   .fail(function (response) {
    //     $this[0].props.history.push("/login");
    //     localStorage.setItem("isLogged", false);
    //     $this[0].setState({
    //       isLogged: false,
    //     });
    //   });
  };
  //------------------------------------------------ POST -------------------------------------------------------
  const postRenewToken = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/renew-token`,
      method: "POST",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    // $.ajax(settings)
    // // En caso de ser correcta logeamos
    // .done($this[0].loggedIn)
    // // En caso de fallo deslogueamos
    // .fail($this[0].ErrorHandling);

    $.ajax(settings)
      .done((response) => {
        setAccessToken(response.accessToken);
        setRefreshSuccess(true);
        setRefreshDone(true);
      })
      .fail((error) => {
        logout(false);
        setRefreshDone(true);
      });
  };

  const postRequestLogin = (data) => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/get-token`,
      method: "POST",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: {
        username: data.username,
        password: data.password,
      },
    };

    $.ajax(settings)
      .done((response) => {
        setLoginSuccess(true);
        setAccessToken(response.accessToken);
        localStorage.setItem("accessToken", response.accessToken);
        
        //setAlert("", "Hay un caracono por aquí "+response.accessToken, "success");
      
        // $this[0].props.setAlert("", "Se ha registrado correctamente", "success");
        // $this[0].props.loggedIn();
      })
      .fail((response) => {
        logout(false);
        addAlert("Error", "Login incorrecto", "danger");
        // $this[0].props.setAlert("Error - ", "Login Incorrecto", "danger");
      });
  };

  const requestLogout = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/logout`,
      method: "POST",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    $.ajax(settings);
  };

  // Función que se ejecuta cuando el usuario le da a salir. Invalida el token
  const logout = (cancelToken = true) => {
    if (cancelToken) {
      requestLogout();
      history.push("/login");
    }
    setAccessToken("");
    setAccessLevel(0);
    setPerfil({});
    setLoginSuccess(false);
    //console.log('aqui estoy con el error')
    setProfileSuccess(false);
    setRefreshSuccess(false);

    // Ponemos a false las variables de logueado
    // localStorage.setItem("isLogged", false);
    // $this[0].props.history.push("/login");
    // $this[0].setState({
    //   isLogged: false,
    // });
  };

  // TODO ALERTAS, esto deberíamos limpiarlo
  // Funcion que añade una alerta y la muestra
  const setAlert = (title, body, type) => {
    addAlert(title, body, type);
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <>
    {
    //console.log(process.env)
    }
      <ConfirmModalProvider>
        <ModalProvider>
          {isReady() ? (
            <Switch>
              <GuardedRoute
                exact
                path="/login"
                component={Login}
                condition={accessLevel <= 0}
                ErrorHandling={ErrorHandling}
                redirect={"/provincias"}
                setAlert={setAlert}
                perfil={perfil}
                submissionHandler={postRequestLogin}
              />
              <Route exact path="/new-password">
                <RecuperarContraseña />
              </Route>
              <GuardedRoute
                path="/"
                component={Root}
                condition={accessLevel > 1}
                ErrorHandling={ErrorHandling}
                logout={logout}
                isLogged={loginSuccess}
                redirect="/login"
                setAlert={setAlert}
                perfil={perfil}
              />
            </Switch>
          ) : null}
        </ModalProvider>
        <Footer></Footer>
      </ConfirmModalProvider>
    </>
  );
};
export default App;
